import React from 'react';
export const MechanismSection = () => {
  return <section className="bg-gradient-to-b from-teal-700 to-teal-600 text-white py-16" data-id="element-228">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-229">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 text-center" data-id="element-230">
          The Unique Mechanism That Powers Neurotoned:
        </h2>
        <h3 className="text-2xl font-semibold mb-8 text-center" data-id="element-231">
          The 4-Layer Nervous System Healing Stack
        </h3>
        <div className="mb-10 max-w-2xl mx-auto" data-id="element-232">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/n1mjfwQaGVcc68mfnupbsc/17cef8e-2885-4324-66a2-30e65137f44_fibromyalgiaNervePainBrain-1067733668-770x553_jpg_%281%29.webp" alt="Brain with neural connections illustration" className="w-full rounded-lg shadow-xl mb-8" data-id="element-233" />
          <p className="text-lg font-bold mb-6 text-center" data-id="element-234">
            <strong data-id="element-235">We don't throw random somatic tools at you.</strong> We
            sequence them intentionally across 4 healing layers:
          </p>
          <div className="space-y-8" data-id="element-236">
            <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-237">
              <h4 className="text-xl font-bold mb-3" data-id="element-238">
                1. Physiological Safety:
              </h4>
              <ul className="list-disc pl-6 space-y-2" data-id="element-239">
                <li data-id="element-240">Reset your vagus nerve</li>
                <li data-id="element-241">Build capacity without overwhelm</li>
                <li data-id="element-242">Feel safe in your body again</li>
              </ul>
            </div>
            <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-243">
              <h4 className="text-xl font-bold mb-3" data-id="element-244">
                2. Sensory Integration:
              </h4>
              <ul className="list-disc pl-6 space-y-2" data-id="element-245">
                <li data-id="element-246">Use sound, touch, and breath to unlock freeze states</li>
                <li data-id="element-247">Discharge stored trauma patterns</li>
              </ul>
            </div>
            <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-248">
              <h4 className="text-xl font-bold mb-3" data-id="element-249">
                3. Expressive Reconnection:
              </h4>
              <ul className="list-disc pl-6 space-y-2" data-id="element-250">
                <li data-id="element-251">Move trauma out through movement, art, and sound</li>
                <li data-id="element-252">Reclaim emotional expression without retraumatization</li>
              </ul>
            </div>
            <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-253">
              <h4 className="text-xl font-bold mb-3" data-id="element-254">
                4. Resilience & Regulation:
              </h4>
              <ul className="list-disc pl-6 space-y-2" data-id="element-255">
                <li data-id="element-256">Daily practices to stabilize calm</li>
                <li data-id="element-257">Tools for triggers, shutdown, and dissociation</li>
              </ul>
            </div>
          </div>
          <p className="mt-8 text-lg text-center" data-id="element-258">
            Each week builds on the last. You're not just learning... you're{' '}
            <em data-id="element-259">rewiring.</em>
          </p>
        </div>
      </div>
    </section>;
};